<template>
  <v-container fluid>
    <v-layout column align-center>
        <v-playback :url="url" style="width:500px;"></v-playback>
      <v-flex xs12 class="text-xs-center" mt-5>
        <h1>Welcome to {{ appTitle }}</h1>
      </v-flex>
      <v-flex xs12 sm6 offset-sm2 mt-3>
        <blockquote class="blockquote text-xs-center">Primerov in house tracking sistem.
          <br>Mora od necega da se pocne.
        </blockquote>
      </v-flex>
      <v-flex xs12 sm6 offset-sm-3 class="text-xs-center" mt-5>
        <v-btn color="primary" to="/signup">Sign Up</v-btn>
        <v-btn to="/signin">Sign In</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      url: "RTS_Spica_v09.mp4"
    };
  },
  computed: {
    appTitle() {
      return this.$store.state.appTitle;
    }
  }
};
</script>

<style scoped>
</style>
